import PageComponent from '/root/workspace/JiaMeiHuiBackstage_3hGC/src/pages/lookJournalism/index';

const PageComponentName = PageComponent;

export default PageComponentName;
